module.exports = {"attributes":{"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"content":"<g>         <path d=\"M2,16 L2,0 L0,0 L0,17 C0,17.552 0.448,18 1,18 L18,18 L18,16 L2,16 Z\"></path>         <path d=\"M8,9.4141 L10.293,11.7071 C10.684,12.0981 11.316,12.0981 11.707,11.7071 L17.707,5.7071 L16.293,4.2931 L11,9.5861 L8.707,7.2931 C8.316,6.9021 7.684,6.9021 7.293,7.2931 L3.293,11.2931 L4.707,12.7071 L8,9.4141 Z\"></path>     </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/_chart.svg
// module id = 1249
// module chunks = 0